@if (showIcon()) {
  <mat-icon class="flex h-3.5 w-3.5 items-center justify-center text-[14px] leading-none">list_alt</mat-icon>
}
{{ "packageConfigurator.label.diagnosesCount" | translate: { count: count() } }}
